import * as Yup from 'yup';

export default Yup.object().shape({
  kimai_user: Yup.string().required('user required'),
  kimai_token: Yup.string().required('token required'),
});
